// UserProfile.js
import React, { useEffect, useState } from 'react';
import decodeTokenAndGetUserId from '../../../utils/decodedToken';

const UserProfile = () => {
  const [userData, setUserData] = useState({
    username: '',
    address: '',
    phone: '',
    // Add other details as needed
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem('token');
      const userId = decodeTokenAndGetUserId(token);
        const response = await fetch(`http://localhost:3000/api/users/details/${userId}`);
        const data = await response.json();
        
        // Assuming the API response has properties like username, address, and phone
        setUserData({
          username: data.username,
          address: data.address,
          phone: data.phone,
          // Add other details as needed
        });
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };

    fetchUserProfile();
  }, []); // The empty dependency array ensures this effect runs only once on component mount

  return (
    <div className=" p-4 md:p-8 mt-16">
    <div className="mt-8">
      <div className="text-2xl font-bold mb-4">Your Profile</div>
      <div className="md:w-96 w-full bg-white rounded-md overflow-hidden shadow-md">
        <div className="p-4 md:p-6">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Username:</label>
            <p className="text-gray-800">{userData.username}</p>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Address:</label>
            <p className="text-gray-800">{userData.address}</p>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Phone Number:</label>
            <p className="text-gray-800">{userData.phone}</p>
          </div>
          {/* Add other details as needed */}
        </div>
      </div>
    </div>
  </div>
  
  );
};

export default UserProfile;
